<template>
	<div class="creatOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				任务大厅
			</div>
		</div>
		<div v-show="showClass==1">
			<table class="layui-table align_center orBoxs" style="width:90%;margin:30px 5% 0;">
				<colgroup>
					<col width="100">
					<col width="300">
					<col>
					<col>
					<col width="150">
				</colgroup>
				<thead>
					<tr>
						<th class="align_center">序号</th>
						<th class="align_center">客户名称</th>
						<th class="align_center">订单编号</th>
						<th class="align_center">订单数量</th>
						<th class="align_center">钢网数量</th>
						<th class="align_center">客户下单时间</th>
						<th class="align_center">订单交付类型</th>
						<th class="align_center">订单操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{ i + 1 }}</td>
						<td>{{ item.company_name }}</td>
						<td>{{ item.order_num }}</td>
						<td>{{item.task_num}}</td>
						<td>{{item.buy_num}}</td>
						<td>{{ item.createtime_text }}</td>
						<td :class="item.is_fast==2?'mon_color':''">{{item.is_fast_text}}</td>
						<td>
							<button type="button" @click="showDetail(item.order_num)" class="layui-btn zt_color pointer">接单</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="8">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'creatOrder',
		data() {
			return {
				dscModel: false,
				showClass: 1,
				tables: '',
				datas: [],
				pages: 1,
				count: 1,
				limit: 10
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			layui.use(['table', 'laypage'], () => {
				var table = layui.table;
				var laypage = layui.laypage;
				api.TaskList({
					token: _this.getCookie('token'),
					page: _this.pages,
					limit: _this.limit
				}).then((res) => {
					if(res.code == 1) {
						_this.datas = res.data.list;
						_this.count = res.data.count;
					}
					laypage.render({
						elem: 'lypages', //注意，这里的 lypages 是 ID，不用加 # 号
						theme: '#4876FF',
						count: _this.count,
						limit: _this.limit,
						jump: function(obj, first) {
							if(!first) {
								_this.pages = obj.curr;
								_this.getData();
							}
						}
					});
				})
			});
		},
		methods: {
			getData() {
				api.TaskList({
					token: this.getCookie('token'),
					page: this.pages,
					limit: this.limit
				}).then((res) => {
					if(res.code == 1) {
						console.log(res.data.list)
						this.datas = res.data.list;
					}
				})
			},
			showDetail(num) {
				let _this = this;
				layui.use(['layer'], () => {
					layer.open({
						title: '提示',
						content: '是否接单',
						btn: ['确定', '取消'],
						closeBtn: 0,
						btnAlign: 'c',
						resize: false,
						skin: 'demo-class',
						yes: function(index, layero) {
							api.receiptOrder({
								token: _this.getCookie('token'),
								order_num: num
							}).then((res) => {
								console.log(res)
								if(res.code == 1) {
									layer.closeAll();
									_this.$router.replace({
										path: '/orderDetail',
										query: {
											id: num
										}
									})
								} else if(res.code == 0) {
									layer.closeAll();
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						},
						btn2: function(index, layero) {

						}
					});
				})

			},
			setClass(e) {
				this.showClass = e;
				if(e == 2) {

				}
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.creatOrder {
		font-family: SourceHanSansSC;
	}
	
	.orBoxs th,
	td {
		/* font-size: 16px; */
	}
</style>


// WEBPACK FOOTER //
// src/components/creatOrder.vue